// src/components/FloatingButtons.jsx
import React from "react";
import whatsappIcon from "../assets/icons/whatsapp.svg";
import formIcon from "../assets/icons/form-icon.png";
import "../styles/FloatingIcons.css";

const FloatingButtons = () => {
  return (
    <>
      <div className="whatsapp-button floating-button">
        <a
          href="https://wa.me/919912754074?text=Hello,%20I'm%20interested%20in%20your%20interior%20design%20services.%20Can%20we%20discuss%20how%20you%20can%20help%20with%20my%20project?"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={whatsappIcon} alt="WhatsApp" />
        </a>
      </div>
      <div className="form-button floating-button">
        <a
          href="https://forms.gle/GRuMZJtvmQDv9oJm8"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={formIcon} alt="Contact Form" />
        </a>
      </div>
    </>
  );
};

export default FloatingButtons;
